import { ArrowUpRight, Mail, MessageCircle, Phone } from 'lucide-react';
import { Reveal } from '../../shared/ui';

const CONTACTS = [
  { label: 'Phone', value: '+1 876 422 5370', href: 'tel:+18764225370', Icon: Phone },
  { label: 'Phone', value: '+1 876 791 1685', href: 'tel:+18767911685', Icon: Phone },
  { label: 'Email', value: 'rtequipment.co.ltd@gmail.com', href: 'mailto:rtequipment.co.ltd@gmail.com', Icon: Mail },
  { label: 'Chat on WhatsApp', value: '+1 876 422 5370', href: 'https://wa.me/18764225370', Icon: MessageCircle },
  { label: 'Chat on WhatsApp', value: '+1 876 791 1685', href: 'https://wa.me/18767911685', Icon: MessageCircle },
];

export function DirectContact() {
  return (
    <section id="contact" className="mx-auto max-w-[1200px] scroll-mt-16 px-[22px] pt-[clamp(96px,14vw,160px)]">
      <div className="flex flex-col gap-8 rounded-[32px] bg-[#161617] p-4 sm:gap-10 sm:p-[clamp(32px,6vw,72px)]">
        <Reveal as="h2" className="m-0 text-[clamp(40px,5vw,56px)] font-bold leading-[1.05] tracking-[-0.04em]">Direct contact</Reveal>
        <Reveal kind="stagger" className="grid gap-3.5 [grid-template-columns:repeat(auto-fit,minmax(min(100%,300px),1fr))]">
          {CONTACTS.map(({ label, value, href, Icon }) => (
            <a
              key={href}
              href={href}
              target={href.startsWith('http') ? '_blank' : undefined}
              rel="noopener noreferrer"
              className="flex items-center gap-3 rounded-3xl border-2 border-[#2c2c2e] bg-[#1c1c1e] px-3.5 py-3 sm:gap-4 sm:px-5 sm:py-[18px] text-[#f5f5f7] transition-all duration-300 hover:-translate-y-1 hover:border-accent hover:shadow-[0_16px_40px_rgba(245,165,36,0.12)]"
            >
              <span className="grid h-10 w-10 flex-none sm:h-12 sm:w-12 place-items-center rounded-full bg-[#2a1d06] text-accent"><Icon size={22} /></span>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-[13px] text-[#86868b]">{label}</span>
                <span className="break-words text-[17px] sm:text-[19px] font-semibold tracking-[-0.015em]">{value}</span>
              </span>
              <ArrowUpRight size={18} className="text-[#6e6e73]" />
            </a>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
